var _g, _path, _text, _text2, _text3, _text4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoResult = function SvgNoResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.126,
    height: 136.157
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 270",
    transform: "translate(28.467 17)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.5,
    r: 45.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.5,
    r: 42.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Linie 166",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "m41.967 94.5-36.31 36"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "?",
    transform: "translate(74.126 83)",
    stroke: "currentColor",
    fill: "currentColor",
    fontSize: 55,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.374,
    y: 0
  }, "?"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    "data-name": "?",
    transform: "translate(131.126 44)",
    stroke: "currentColor",
    fill: "currentColor",
    fontSize: 30,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.295,
    y: 0
  }, "?"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    "data-name": "?",
    transform: "translate(110.126 21)",
    stroke: "currentColor",
    fill: "currentColor",
    fontSize: 20,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -4.863,
    y: 0
  }, "?"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    "data-name": "?",
    transform: "translate(13.126 107.813)",
    stroke: "currentColor",
    fill: "currentColor",
    fontSize: 24,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.836,
    y: 0
  }, "?"))));
};
export default SvgNoResult;